import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export default function PatientNmatch(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g transform="matrix(0.9,0,0,0.9,1.1999999999999993,1.1999024629592885)">
          <g fill="#90a7b2">
            <path
              d="m9.66788 2.72217c.57242-1.31669 1.91902-2.22412 3.45712-2.22412 2.0441 0 3.75 1.60276 3.75 3.63889s-1.7059 3.63888-3.75 3.63888c-.4693 0-.9207-.08446-1.3377-.23924.0575-.28922.0877-.58917.0877-.89757 0-1.67727-.8943-3.10454-2.20712-3.91684z"
              fill="#90a7b2"
              fill-opacity="1"
              data-original-color="#90a7b2ff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m14.4338 11.942c1.0076-.5983 2.1843-.9419 3.4412-.9419.6963 0 1.368.1055 2 .3012v-.5165c0-.4667-.2547-.88513-.6476-1.11131-2.3265-1.33932-5.008-1.84979-7.6051-1.53139-.2458.7044-.6595 1.32639-1.1901 1.82684 1.1413.29256 2.2506.73916 3.2941 1.33996.2788.1605.5195.3769.7075.6331z"
              fill="#90a7b2"
              fill-opacity="1"
              data-original-color="#90a7b2ff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m13.6138 12.5149c-.1038-.1362-.2348-.2521-.3864-.3393-3.75928-2.1642-8.44552-2.1642-12.2048 0-.392882.2261-.64757.6446-.64757 1.1113v2.741c0 .8395.6985 1.4722 1.5 1.4722h9.2545c.0732-2.0104 1.0257-3.7965 2.4843-4.9852z"
              fill="#90a7b2"
              fill-opacity="1"
              data-original-color="#90a7b2ff"
              stroke="none"
              stroke-opacity="1"
            />
            <path
              d="m7.125 3.00012c-2.04414 0-3.75 1.60276-3.75 3.63889s1.70586 3.63889 3.75 3.63889 3.75-1.60276 3.75-3.63889-1.70586-3.63889-3.75-3.63889z"
              fill="#90a7b2"
              fill-opacity="1"
              data-original-color="#90a7b2ff"
              stroke="none"
              stroke-opacity="1"
            />
          </g>
          <g fill-rule="evenodd">
            <path
              d="m13.625 17.75c0-2.3472 1.9028-4.25 4.25-4.25.9027 0 1.7397.2814 2.428.7614l-5.9166 5.9166c-.48-.6883-.7614-1.5253-.7614-2.428zm1.8221 3.4887c.6882.4799 1.5252.7613 2.4279.7613 2.3472 0 4.25-1.9028 4.25-4.25 0-.9027-.2814-1.7397-.7613-2.4279zm2.4279-9.2387c-3.1756 0-5.75 2.5744-5.75 5.75s2.5744 5.75 5.75 5.75 5.75-2.5744 5.75-5.75-2.5744-5.75-5.75-5.75z"
              fill="#f44336"
              fill-opacity="1"
              data-original-color="#f44336ff"
              stroke="none"
              stroke-opacity="1"
            />
            <g fill="#7e97a3">
              <path
                d="m7.06077 17.5002h-5.18577c-.8015 0-1.5-.6327-1.5-1.4722v-2.741c0-.4667.254688-.8852.64757-1.1113 1.8606-1.0712 3.94825-1.6121 6.0382-1.623zm0-7.2227c-2.01552-.0332-3.68577-1.62364-3.68577-3.63841 0-2.01476 1.67025-3.60521 3.68577-3.63836z"
                fill="#7e97a3"
                fill-opacity="1"
                data-original-color="#7e97a3ff"
                stroke="none"
                stroke-opacity="1"
              />
              <path
                d="m13.0767 8.0526v2.9065c-.8501-.4275-1.7372-.7575-2.6446-.9901.53-.49993.9434-1.12115 1.1893-1.82467.4831-.05925.9691-.08983 1.4553-.09173zm0-7.55211v7.27718c-.4521-.00558-.8871-.08952-1.29-.23909.0578-.28982.0882-.59041.0882-.8995 0-1.67696-.894-3.10403-2.20644-3.9164.56684-1.30204 1.89084-2.20347 3.40824-2.22219z"
                fill="#7e97a3"
                fill-opacity="1"
                data-original-color="#7e97a3ff"
                stroke="none"
                stroke-opacity="1"
              />
              <path
                d="m17.875 12c-3.1756 0-5.75 2.5744-5.75 5.75s2.5744 5.75 5.75 5.75v-1.5c-.9027 0-1.7397-.2814-2.4279-.7613l2.4279-2.428v-2.1213l-3.4886 3.4886c-.48-.6883-.7614-1.5253-.7614-2.428 0-2.3472 1.9028-4.25 4.25-4.25z"
                fill="#cc382d"
                fill-opacity="1"
                data-original-color="#cc382dff"
                stroke="none"
                stroke-opacity="1"
              />
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
